import api from "./api";

const notificationService = {
  /**
   * Get user notifications with pagination
   * @param {Object} params - { page, limit, unreadOnly }
   */
  getNotifications: async (params = {}) => {
    try {
      const response = await api.get("/notifications", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  },

  /**
   * Get unread notifications count
   */
  getUnreadCount: async () => {
    try {
      const response = await api.get("/notifications/unread-count");
      return response.data.count;
    } catch (error) {
      console.error("Error fetching unread count:", error);
      throw error;
    }
  },

  /**
   * Mark a notification as read
   */
  markAsRead: async (id) => {
    try {
      const response = await api.put(`/notifications/${id}/read`);
      return response.data;
    } catch (error) {
      console.error("Error marking notification as read:", error);
      throw error;
    }
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead: async () => {
    try {
      const response = await api.put("/notifications/read-all");
      return response.data;
    } catch (error) {
      console.error("Error marking all as read:", error);
      throw error;
    }
  },

  /**
   * Get admin-specific notifications
   * @param {Object} params - { page, limit, unreadOnly }
   */
  getAdminNotifications: async (params = {}) => {
    try {
      const response = await api.get("/admin/notifications", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching admin notifications:", error);
      throw error;
    }
  },
};

export default notificationService;
